import { render } from "./ModalRule.vue?vue&type=template&id=793b28b2&scoped=true&ts=true"
import script from "./ModalRule.vue?vue&type=script&lang=ts"
export * from "./ModalRule.vue?vue&type=script&lang=ts"

import "./ModalRule.vue?vue&type=style&index=0&id=793b28b2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793b28b2"]])

export default __exports__